import { isAnyOf } from "@reduxjs/toolkit";

import { authSliceActions } from "@/store/slices/auth";
import { notificationSliceActions } from "@/store/slices/notification";
import { addAppMiddleware } from "@/store/utils";

const { requestPermission, registerVisibilityListener, cleanup } = notificationSliceActions;
const { setExpeditionCredentials, setDriverCredentials, logout } = authSliceActions;

addAppMiddleware(({ dispatch }) => (next) => (action) => {
  const result = next(action);

  const isLogin = isAnyOf(setExpeditionCredentials, setDriverCredentials)(action);
  const isLogout = logout.match(action);

  if (isLogin) {
    dispatch(requestPermission());
    dispatch(registerVisibilityListener());
  }

  if (isLogout) {
    dispatch(cleanup());
  }

  return result;
});
